(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cat-carousel')) {
    customElements.define('cat-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.i = 0;
        const next = this.querySelector('[data-next]');
        if (next && this.slides.length > 1) {
          next.addEventListener('click', (e) => { e.preventDefault(); this.go(this.i + 1); });
        }
      }
      go(n) {
        const len = this.slides.length;
        if (!len) return;
        this.i = (n + len) % len;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
      }
    });
  }
  if (!customElements.get('cat-video')) {
    customElements.define('cat-video', class extends HTMLElement {
      connectedCallback() {
        const src = this.dataset.src;
        if (!src) return;
        const load = () => {
          if (this._loaded) return;
          this._loaded = true;
          const v = document.createElement('video');
          v.className = 'cat__feature-video';
          v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
          v.setAttribute('preload', 'none');
          v.setAttribute('aria-hidden', 'true');
          if (this.dataset.poster) v.poster = this.dataset.poster;
          const s = document.createElement('source');
          s.src = src; s.type = 'video/mp4';
          v.appendChild(s);
          this.appendChild(v);
          const p = v.play();
          if (p && p.catch) p.catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) { load(); io.disconnect(); } });
          }, { rootMargin: '200px' });
          io.observe(this);
        } else {
          load();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dji-category-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('djcat-carousel')) {
    customElements.define('djcat-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.i = 0;
        if (this.slides.length > 1) {
          const next = this.querySelector('[data-next]');
          const prev = this.querySelector('[data-prev]');
          if (next) next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.go(this.i + 1); });
          if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.go(this.i - 1); });
        }
      }
      go(n) {
        const len = this.slides.length;
        if (!len || !this.track) return;
        this.i = (n + len) % len;
        this.track.style.transform = 'translateX(-' + (this.i * 100) + '%)';
      }
    });
  }
  if (!customElements.get('djcat-video')) {
    customElements.define('djcat-video', class extends HTMLElement {
      connectedCallback() {
        const src = this.dataset.src;
        if (!src) return;
        const load = () => {
          if (this._loaded) return;
          this._loaded = true;
          const v = document.createElement('video');
          v.className = 'djcat__feature-video';
          v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
          v.setAttribute('preload', 'none');
          v.setAttribute('aria-hidden', 'true');
          if (this.dataset.poster) v.poster = this.dataset.poster;
          const s = document.createElement('source');
          s.src = src; s.type = 'video/mp4';
          v.appendChild(s);
          this.appendChild(v);
          const p = v.play();
          if (p && p.catch) p.catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) { load(); io.disconnect(); } });
          }, { rootMargin: '200px' });
          io.observe(this);
        } else {
          load();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dji-spec-table"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSpecTable(section){
      if (!section) return;
      var sidebarItems = section.querySelectorAll('.dji-spec-table__sidebar-item');
      var groups = section.querySelectorAll('.dji-spec-table__group');
      if (sidebarItems.length === 0) return;
      sidebarItems.forEach(function(item){
        item.addEventListener('click', function(e){
          e.preventDefault();
          var targetId = this.getAttribute('href').replace('#','');
          var target = document.getElementById(targetId);
          if (target) target.scrollIntoView({behavior:'smooth',block:'start'});
        });
      });
      window.addEventListener('scroll', function(){
        var scrollPos = window.scrollY + 100;
        groups.forEach(function(g, i){
          if (g.offsetTop <= scrollPos && g.offsetTop + g.offsetHeight > scrollPos) {
            sidebarItems.forEach(function(s){ s.classList.remove('is-active'); });
            if (sidebarItems[i]) sidebarItems[i].classList.add('is-active');
          }
        });
      });
    }
    document.querySelectorAll('.dji-spec-table').forEach(initSpecTable);
    document.addEventListener('shopify:section:load', function(event){
      var section = event.target.querySelector('.dji-spec-table');
      if (section) initSpecTable(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CartCount extends HTMLElement {
    connectedCallback() {
      this._on = (e) => this.refresh(e);
      document.addEventListener('cart:updated', this._on);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._on);
    }
    async refresh(e) {
      try {
        const fromDetail = e && e.detail && e.detail.cartData && typeof e.detail.cartData.item_count === 'number'
          ? e.detail.cartData.item_count
          : null;
        if (fromDetail != null) {
          this.textContent = String(fromDetail);
          return;
        }
        const c = await (await fetch('/cart.js')).json();
        this.textContent = c.item_count;
      } catch (err) {}
    }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  class MegaMenu extends HTMLElement {
    connectedCallback() {
      this.cats = Array.from(this.querySelectorAll('[data-mega-cat]'));
      this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      this.cats.forEach((c) => {
        const show = () => this.activate(c.getAttribute('data-mega-cat'));
        c.addEventListener('mouseenter', show);
        c.addEventListener('focus', show);
      });
    }
    activate(idx) {
      this.cats.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-mega-cat') === idx));
      this.panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === idx));
    }
  }
  if (!customElements.get('mega-menu')) customElements.define('mega-menu', MegaMenu);

  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const burger = header.querySelector('[data-burger]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-drawer-close]');
    const toggle = (open) => {
      const willOpen = open ?? drawer.hasAttribute('hidden');
      [drawer, overlay].forEach(el => { if (!el) return; if (willOpen) { el.removeAttribute('hidden'); requestAnimationFrame(() => el.classList.add('is-open')); } else { el.classList.remove('is-open'); setTimeout(() => el.setAttribute('hidden', ''), 300); } });
      burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) { window.MetryScrollLock.lock(); } else { window.MetryScrollLock.unlock(); }
    };
    if (burger && drawer) {
      burger.addEventListener('click', () => toggle());
      if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
      if (overlay) overlay.addEventListener('click', () => toggle(false));
      drawer.addEventListener('click', e => { if (e.target.tagName === 'A') toggle(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) toggle(false); });
    }
  })();

  /* Mobile drawer accordion: only one first-level <details.header__acc> stays open at a time.
     Scoped to the drawer list so mega/cart <details> elsewhere are untouched. The toggle event
     does not bubble, so listen in the capture phase and filter by target. */
  (function () {
    const drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    const list = drawer.querySelector('.header__drawer-list');
    if (!list) return;
    list.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('header__acc') || !d.open) return;
      list.querySelectorAll('details.header__acc[open]').forEach((other) => { if (other !== d) other.open = false; });
    }, true);
  })();

  /* Sticky header: toggle .is-scrolled to reveal the elevation shadow once scrolled. */
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    let ticking = false;
    const update = () => { header.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; };
    update();
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  })();

  /* The campaign banner is injected as a separate sticky custom element before
     the Header Group. Keep this header below its actual rendered height rather
     than competing for top: 0 with a higher z-index. */
  (function () {
    const header = document.querySelector('[data-header]');
    const headerGroup = header && header.closest('.shopify-section-group-header-group');
    if (!headerGroup) return;

    headerGroup.__djiStickyOffsetController?.destroy();

    const abortController = new AbortController();
    let banner = null;
    let resizeObserver = null;

    const syncOffset = () => {
      if (!banner) {
        headerGroup.style.setProperty('--dji-header-sticky-top', '0px');
        return;
      }

      const style = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      const isPinned = (style.position === 'fixed' || style.position === 'sticky')
        && style.display !== 'none'
        && style.visibility !== 'hidden'
        && rect.height > 0
        && rect.bottom > 0;

      headerGroup.style.setProperty('--dji-header-sticky-top', isPinned ? `${Math.ceil(rect.height)}px` : '0px');
    };

    const observeBanner = () => {
      const nextBanner = document.querySelector('single-banner');
      if (nextBanner === banner) {
        syncOffset();
        return;
      }

      resizeObserver?.disconnect();
      banner = nextBanner;
      if (banner && 'ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(syncOffset);
        resizeObserver.observe(banner);
      }
      syncOffset();
    };

    const bodyObserver = new MutationObserver(observeBanner);
    bodyObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', syncOffset, { passive: true, signal: abortController.signal });
    document.addEventListener('shopify:section:load', observeBanner, { signal: abortController.signal });

    const destroy = () => {
      abortController.abort();
      bodyObserver.disconnect();
      resizeObserver?.disconnect();
      headerGroup.style.removeProperty('--dji-header-sticky-top');
      delete headerGroup.__djiStickyOffsetController;
    };

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === headerGroup || event.target.contains(header)) destroy();
    }, { signal: abortController.signal });

    headerGroup.__djiStickyOffsetController = { destroy };
    observeBanner();
  })();

  /* Mega dropdown hover-intent: keep the panel open for a short delay after the pointer leaves the
     top-level item, so crossing the gap into the panel doesn't momentarily drop :hover and hide it.
     Drives the panel via inline styles (highest priority) so it works regardless of :hover state. */
  (function () {
    const CLOSE_DELAY = 220;
    document.querySelectorAll('.header__nav-item.has-mega').forEach((li) => {
      const mega = li.querySelector('.header__mega');
      if (!mega) return;
      let timer = null;
      const show = () => {
        if (timer) { clearTimeout(timer); timer = null; }
        li.classList.add('is-open');
        // !important so it wins even over any global rule that force-hides panels on this page.
        mega.style.setProperty('opacity', '1', 'important');
        mega.style.setProperty('visibility', 'visible', 'important');
        mega.style.setProperty('transform', 'none', 'important');
        mega.style.setProperty('pointer-events', 'auto', 'important');
      };
      const hide = () => {
        li.classList.remove('is-open');
        mega.style.removeProperty('opacity');
        mega.style.removeProperty('visibility');
        mega.style.removeProperty('transform');
        mega.style.removeProperty('pointer-events');
      };
      const close = () => { if (timer) clearTimeout(timer); timer = setTimeout(hide, CLOSE_DELAY); };
      li.addEventListener('mouseenter', show);
      li.addEventListener('mouseleave', close);
      li.addEventListener('focusin', show);
      li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-promo"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.i = 0;
      if (this.slides.length < 2) return;
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-prev]')) { this.go(this.i - 1); this.restart(); return; }
        if (e.target.closest('[data-next]')) { this.go(this.i + 1); this.restart(); return; }
        const d = e.target.closest('[data-dot]');
        if (d) { this.go(parseInt(d.dataset.dot, 10)); this.restart(); }
      });
      this.bindSwipe();
      if (this.dataset.autoplay === 'true') {
        this.restart();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }
    }
    bindSwipe() {
      const vp = this.querySelector('.hpromo__viewport') || this;
      let x0 = 0, y0 = 0, active = false, horizontal = false;
      vp.addEventListener('touchstart', (e) => {
        const t = e.changedTouches[0];
        x0 = t.clientX; y0 = t.clientY; active = true; horizontal = false;
        this.stop();
      }, { passive: true });
      vp.addEventListener('touchmove', (e) => {
        if (!active) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        // Only hijack the gesture when it is clearly horizontal; otherwise let the page scroll.
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          horizontal = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });
      const end = (e) => {
        if (!active) return;
        active = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        if (horizontal && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) { this.go(this.i + 1); } else { this.go(this.i - 1); }
        }
        this.start();
      };
      vp.addEventListener('touchend', end, { passive: true });
      vp.addEventListener('touchcancel', end, { passive: true });
    }
    go(n) {
      const len = this.slides.length;
      this.i = (n + len) % len;
      this.track.style.transform = 'translateX(-' + (this.i * 100) + '%)';
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
      this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.i); d.setAttribute('aria-current', k === this.i ? 'true' : 'false'); });
    }
    start() { if (this.dataset.autoplay !== 'true') return; this.timer = setInterval(() => this.go(this.i + 1), parseInt(this.dataset.interval, 10) || 6000); }
    stop() { if (this.timer) clearInterval(this.timer); }
    restart() { this.stop(); this.start(); }
  }
  if (!customElements.get('hero-carousel')) customElements.define('hero-carousel', HeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-products-display"] && !Shopify.designMode) return;
  try {
    
  class OfferCopyToClipboard extends HTMLButtonElement {
    constructor() {
      super();
      this.copyId = this.dataset.id; // Get the `data-id` attribute value
      this.copiedText = this.dataset.copied || 'Copied!'; // Text to show when copied
      this.init();
    }

    init() {
      this.addEventListener('click', this.handleCopy.bind(this));
    }

    async handleCopy() {
      if (!this.copyId) {
        console.error('No data-id found to copy!');
        return;
      }

      try {
        // Attempt to use the Clipboard API
        await navigator.clipboard.writeText(this.copyId);
        this.showCopiedMessage();
      } catch (error) {
        // Fallback to execCommand if Clipboard API fails
        console.warn('Clipboard API failed, falling back to execCommand:', error);
        this.fallbackCopy();
      }
    }

    fallbackCopy() {
      const tempInput = document.createElement('input');
      tempInput.value = this.copyId;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);

      tempInput.select();
      document.execCommand('copy'); // Deprecated but used as a fallback
      document.body.removeChild(tempInput);

      this.showCopiedMessage();
    }

    showCopiedMessage() {
      const copiedMessage = document.createElement('div');
      copiedMessage.textContent = this.copiedText;
      copiedMessage.className = 'offer-copied-message';
      copiedMessage.style.opacity = '0';

      this.closest('[data-clipboard-wrapper]')?.appendChild(copiedMessage);

      setTimeout(() => {
        copiedMessage.style.opacity = '1';
      }, 0);

      setTimeout(() => {
        copiedMessage.style.opacity = '0';
        copiedMessage.remove();
      }, 2000);
    }
  }
  customElements.define('offer-copy-to-clipboard', OfferCopyToClipboard, { extends: 'button' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-icon-strip"] && !Shopify.designMode) return;
  try {
    
  class IconStripCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-strip-track]');
      this.prev = this.querySelector('[data-dir="prev"]');
      this.next = this.querySelector('[data-dir="next"]');
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      this._onScroll = () => this.update();
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
    step(dir) {
      // Manual rAF tween — native smooth scrollBy is unreliable on this scroller, so animate scrollLeft directly.
      var amount = Math.max(this.track.clientWidth * 0.8, 240);
      var start = this.track.scrollLeft;
      var target = Math.max(0, Math.min(start + dir * amount, this.track.scrollWidth - this.track.clientWidth));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.track.scrollLeft = target; return; }
      var t0 = performance.now();
      var dur = 320;
      var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
      var self = this;
      var tick = function (now) {
        var p = Math.min((now - t0) / dur, 1);
        self.track.scrollLeft = start + (target - start) * ease(p);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prev) this.prev.hidden = !(max > 4 && x > 4);
      if (this.next) this.next.hidden = !(max > 4 && x < max - 4);
    }
  }
  if (!customElements.get('icon-strip-carousel')) customElements.define('icon-strip-carousel', IconStripCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-variant-sync"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const sync = () => {
        const input = document.querySelector('[data-variant-id], input[name="id"]');
        if (!input || !input.value) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
        document.dispatchEvent(new CustomEvent('dji:variant-change', { detail: { variantId: input.value } }));
      };
      document.addEventListener('change', sync);
      document.addEventListener('input', sync);
      document.addEventListener('variant:change', sync);
      document.addEventListener('shopify:variant:change', sync);
    };
    document.querySelectorAll('[data-product-variant-sync]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-product-variant-sync]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class BgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); this.observer.disconnect(); }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    load() {
      const src = this.video.getAttribute('data-src');
      if (src && !this.video.src) {
        var host = this;
        var revealed = false;
        var reveal = function () {
          if (!revealed) { revealed = true; host.classList.add('is-playing'); }
        };
        if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('playing', function () { setTimeout(reveal, 500); }, { once: true });
        }
        this.video.src = src;
        this.video.play().catch(function () {});
      }
    }
  }
  if (!customElements.get('bg-video')) customElements.define('bg-video', BgVideo);

  } catch(e) { console.error(e); }
})();
})();
